
import React from 'react';
import { FormGroup, Label, Input } from 'reactstrap';
import { connect } from 'react-redux';
//import Slider from "react-slick";
//import axios from 'axios'
//import { auth } from '../../../../../../services';
//import { ROOT_API_URL } from "../../../../../../api-config";
import { updateCard } from '../../../../../Redux/Actions/EndUser/StoreActions';

class StoreCardInfo extends React.Component {
    constructor(props) {
        super(props);

        var creditCard = props.store && props.store.creditCard ? props.store.creditCard : null;

        this.state = {
            NameOnCard: creditCard && creditCard.NameOnCard ? creditCard.NameOnCard : "",
            CardNumber: creditCard && creditCard.CardNumber ? creditCard.CardNumber : "",
            CardExpYear: creditCard && creditCard.CardExpYear ? creditCard.CardExpYear : "",
            CardExpMonth: creditCard && creditCard.CardExpMonth ? creditCard.CardExpMonth : "",
            CardCVC: creditCard && creditCard.CardCVC ? creditCard.CardCVC : ""
        };
    }

    handleChange = (event) => {
        this.setState({
            [event.target.name]: event.target.value
        }, function () {
            this.props.updateCard(this.state);
        });
    }

    cc_format(value) {
        var v = value.replace(/\s+/g, '').replace(/[^0-9]/gi, '');
        var matches = v.match(/\d{4,16}/g);
        var match = matches && matches[0] || '';
        var parts = [];

        for (var i = 0; i < match.length; i += 4) {
            parts.push(match.substring(i, i + 4))
        }

        if (parts.length) {
            return parts.join(' ');
        } else {
            return value;
        }
    }

    handleCreditNumChange = (event) => {
        const value = event.target.value.replace(/\s/g, '').replace(/\D/g, '');

        if ((value.match(/^[0-9999999999999999]|^$/) || value == "") && value.length <= 16) {
            var formattedNum = this.cc_format(value);
            this.setState({
                CardNumber: formattedNum
            }, function () {
                this.props.updateCard(this.state);
            });
        }
    }

    handleExpYearChange = (event) => {
        var originalValue = this.state.CardExpYear;
        const value = event.target.value.replace(/\s/g, '');

        if ((value.match(/^(0)$|^([0-9][0-9]*)$|^$/) || value == "") && value.length <= 2) {
            
            this.setState({
                CardExpYear: value
            }, function () {
                this.props.updateCard(this.state);
            });
        }
    }

    expirationMonthChange = (event) => {
        if (event.target.value.match(/(^[0]$)|(^0?[1-9]$)|(^1[0-2]$)|(^$)/)) {
            this.setState({
                [event.target.name]: event.target.value
            }, function () {
                this.props.updateCard(this.state);
            });
        }
    }

    handleCVCChange = (event) => {
        const value = event.target.value.replace(/\D/g, '');

        if ((value.match(/^[0-9999]|$/) || value == "") && value.length <= 4) {
            this.setState({
                CardCVC: value
            }, function () {
                    this.props.updateCard(this.state);
            });
        }
    }

    render() {
        return (
            <div className="">
                <div className="row">
                    <div className="col-sm-12 card-section-name">
                        <FormGroup>
                            <Label htmlFor="NameOnCard">Full Name on Card</Label>
                            <Input
                                id="NameOnCard"
                                value={this.state.NameOnCard}
                                onChange={this.handleChange}
                                name="NameOnCard"
                                minLength={2}
                                invalid={this.props.touched.NameOnCard && this.state.NameOnCard === '' ? true : false}
                                onBlur={this.props.handleBlur('NameOnCard')}
                            />
                        </FormGroup>
                    </div>
                {/* </div>
                <div className="row"> */}
                    <div className="col-sm-12 card-section-number">
                        <FormGroup>
                            <Label htmlFor="CardNumber">Card Number</Label>
                            <Input
                                id="CardNumber"
                                value={this.state.CardNumber}
                                onChange={this.handleCreditNumChange}
                                name="CardNumber"
                                invalid={this.props.touched.CardNumber && this.state.CardNumber === '' ? true : false}
                                onBlur={this.props.handleBlur('CardNumber')}
                                placeholder="XXXX XXXX XXXX XXXX"
                                pattern="\d{4} \d{4,6} \d{4,5} \d{4,0}"
                            />
                        </FormGroup>
                    </div>
                {/* </div>
                <div className="row"> */}
                    <div className="col card-col card-section-month">
                        <FormGroup>
                            <Label htmlFor="cardExpMonth">Exp Month</Label>
                            <Input
                                id="CardExpMonth"
                                value={this.state.CardExpMonth}
                                onChange={this.expirationMonthChange}
                                name="CardExpMonth"
                                minLength={2}
                                maxLength={2}
                                invalid={this.props.touched.CardExpMonth && this.state.CardExpMonth === '' ? true : false}
                                onBlur={this.props.handleBlur('CardExpMonth')}
                                placeholder="MM"
                                pattern="[0123456789][0123456789]"
                            />
                        </FormGroup>
                    </div>
                    <div className="col card-col card-section-year">
                        <FormGroup>
                            <Label htmlFor="CardExpYear">Exp Year</Label>
                            <Input
                                id="CardExpYear"
                                value={this.state.CardExpYear}
                                onChange={this.handleExpYearChange}
                                name="CardExpYear"
                                minLength={2}
                                maxLength={2}
                                invalid={this.props.touched.CardExpYear && this.state.CardExpYear === '' ? true : false}
                                onBlur={this.props.handleBlur('CardExpYear')}
                                placeholder="YY"
                                pattern="[0123456789][0123456789]"
                            />
                        </FormGroup>
                    </div>
                    <div className="col card-col card-section-cvc">
                        <FormGroup>
                            <Label htmlFor="CardCVC">CVC Code</Label>
                            <Input
                                id="CardCVC"
                                value={this.state.CardCVC}
                                onChange={this.handleCVCChange}
                                name="CardCVC"
                                minLength={2}
                                maxLength={4}
                                invalid={this.props.touched.CardCVC && this.state.CardCVC === '' ? true : false}
                                onBlur={this.props.handleBlur('CardCVC')}
                            />
                        </FormGroup>
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        store: state.store
    }
}

export default connect(mapStateToProps, { updateCard })(StoreCardInfo);
